import React, {Fragment} from 'react';
import withMainLayout from 'layouts/main';
import dynamic from 'next/dynamic';
import SecurityHero from '@/content/security/hero';

const seoMetas = {
  title: 'Security | Workable',
  description:
    'Workable provides world-class security to keep your data safe and your teams moving forward.',
  canonical: 'https://www.workable.com/security'
};

// Dynamic Content Components import
const SecurityDataSection = dynamic(() => import('@/content/security/security-data'), {
  loading: () => null
});
const PartnerAssessments = dynamic(() => import('@/content/security/partner-assessments'), {
  loading: () => null
});
const ComplianceCertifications = dynamic(
  () => import('@/content/security/compliance-certifications'),
  {
    loading: () => null
  }
);
const LearnMore = dynamic(() => import('@/content/security/learn-more'), {
  loading: () => null
});
const UsefulLinks = dynamic(() => import('@/content/security/useful-links'), {
  loading: () => null
});
const PreFooter = dynamic(() => import('../components/prefooter'), {
  loading: () => null
});

const SecurityPage = props => (
  <>
    <SecurityHero />
    <SecurityDataSection />
    <PartnerAssessments />
    <ComplianceCertifications />
    <LearnMore />
    <UsefulLinks />
    <PreFooter />
  </>
);

export default withMainLayout(SecurityPage, {...seoMetas});

export {getSharedPageStaticProps as getStaticProps} from 'helpers/sharedPageStaticProps';
